// Pinia store dla UI list poszukiwanych — przechowuje listę grup kontaktów
// (cache z backendu) używaną przez kreatory pojedynczej tablicy i importu CSV.

import { defineStore } from "pinia";
import ContactGroupsService from "@/services/ContactGroupsService";

export const useWantedStore = defineStore("wanted", {
  state: () => ({
    contactGroups: [],
    loading: false,
    lastFetchError: null,
  }),
  actions: {
    async fetchContactGroups({ force = false } = {}) {
      if (!force && this.contactGroups.length > 0) {
        return this.contactGroups;
      }
      this.loading = true;
      this.lastFetchError = null;
      try {
        const response = await ContactGroupsService.getAll();
        this.contactGroups = (Array.isArray(response) ? response : []).map(group => ({
          id: Number(group.id),
          name: String(group.name ?? ''),
          description: String(group.description ?? ''),
          contactIds: Array.isArray(group.contactIds) ? group.contactIds.map(Number) : [],
          contactsSummary: group.contactsSummary ?? { count: 0, emails: 0, sms: 0, mms: 0 },
        }));
        return this.contactGroups;
      } catch (error) {
        this.lastFetchError = error;
        this.contactGroups = [];
        return [];
      } finally {
        this.loading = false;
      }
    },
  },
});
